module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/payment-list/payment-list.component.css
// module id = ./src/app/payment-list/payment-list.component.css
// module chunks = main